import { Typography } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import PropTypes from "prop-types";
import Lang from "../Utils/lang";
import { useEffect, useState } from "react";
import EvacuationType from "./components/EvacuationType";
import EnvironmentName from "./components/EnvironmentName";
import style from "./Form.module.scss";

const lang = Lang.getInstance();

function SystemDataTreatment({ isModal, form, setForm }) {
  const [systemDataTreatment, setSystemDataTreatment] = useState({
    evacuationType: "",
    authorizationNumber: "",
    existEnvironmentName: "",
    economicOperatorName: "",
    collectionInterval: "",
  });

  /**
   *
   */
  useEffect(() => {
    if (Object.keys(form.systemDataTreatment).length !== 0) {
      setSystemDataTreatment(form.systemDataTreatment);
    }
  }, [form.systemDataTreatment]);

  /**
   *
   * @param {*} event
   */
  function onChange(event) {
    let newSystemDataTreatment = Object.assign({}, systemDataTreatment);
    newSystemDataTreatment[event.target.name] = event.target.value;
    setSystemDataTreatment(newSystemDataTreatment);
    setForm({ ...form, systemDataTreatment: newSystemDataTreatment });
  }

  return (
    <div className={style.systemDataCollectionContainer}>
      <p
        className={
          isModal
            ? style.systemDataCollectionTitleModal
            : style.systemDataCollectionTitle
        }
      >
        Date sistem individual - EPURARE
      </p>
      <EvacuationType
        systemDataTreatment={systemDataTreatment}
        form={form}
        setSystemDataTreatment={setSystemDataTreatment}
        setForm={setForm}
      />
      <div className={style.systemDataCollectionTextField}>
        <Typography style={{ paddingBottom: 0 }}>
          Număr autorizație de gospodărire a apelor
        </Typography>
        <TextValidator
          type="text"
          name="authorizationNumber"
          variant="standard"
          fullWidth
          value={systemDataTreatment.authorizationNumber}
          onChange={(e) => onChange(e)}
          validators={["required"]}
          errorMessages={[lang.get("textFieldRequired")]}
          style={{ marginLeft: 10 }}
        />
      </div>
      <EnvironmentName
        systemDataTreatment={systemDataTreatment}
        form={form}
        setSystemDataTreatment={setSystemDataTreatment}
        setForm={setForm}
        onChange={onChange}
      />
      <div className={style.systemDataCollectionTextField}>
        <Typography style={{ paddingBottom: 0 }}>
          Nume operator economic care vidanjează nămol și număr contract
        </Typography>
        <TextValidator
          type="text"
          name="economicOperatorName"
          variant="standard"
          fullWidth
          value={systemDataTreatment.economicOperatorName}
          onChange={(e) => onChange(e)}
          validators={["required"]}
          errorMessages={[lang.get("textFieldRequired")]}
          style={{ marginLeft: 10 }}
        />
      </div>
      <div className={style.systemDataCollectionTextField}>
        <Typography style={{ paddingBottom: 0 }}>
          Interval de preluare a nămolului
        </Typography>
        <TextValidator
          type="text"
          name="collectionInterval"
          variant="standard"
          fullWidth
          value={systemDataTreatment.collectionInterval}
          onChange={(e) => onChange(e)}
          validators={["required"]}
          errorMessages={[lang.get("textFieldRequired")]}
          style={{ marginLeft: 10 }}
        />
      </div>
    </div>
  );
}

export default SystemDataTreatment;
SystemDataTreatment.propTypes = {
  isModal: PropTypes.bool,
  form: PropTypes.object,
  setForm: PropTypes.func,
};
